/*global document, location */

const initHTML = () => {
    // For Android app, to avoid initial white flash
    if (/[?&]theme=dark/.test(location.search)) {
        document.documentElement.classList.add('prefersdark');
    }

    // Remove loading error text node
    const loadingErrorText = document.getElementById('loading-error');
    if (loadingErrorText) {
        loadingErrorText.remove();
    }
};

// ---

export { initHTML };
